import { Icon, ICON_SIZE, type IconName } from '../chrome/icons';
import { Menu, useMenu, type MenuEntry } from '../../ui/menu';
import { tip } from '../../ui/tooltip';
import { split } from './ToolOptions';

/**
 * A tool's long choice — a size, say — as one button naming what is chosen, and a menu.
 *
 * The strip is a row, so the button is as wide as the name it shows and no wider; the
 * menu opens above it because the strip sits on the dock at the bottom of the window.
 *
 * With a `label` the button says what it is a choice OF before it says the choice — "Where
 * Around a spot" — which is what keeps two pop-ups side by side from being two answers
 * with no questions. With `action` it is a menu of things to do, so it carries no chevron:
 * nothing in it is "the current one".
 */
export function MenuWell({
  well,
  placement = 'above',
  wide = false,
}: {
  well: { icon?: IconName; title: string; value: string; items: readonly MenuEntry[]; label?: string; action?: boolean };
  placement?: 'above' | 'below';
  wide?: boolean;
}) {
  const menu = useMenu();
  const said = split(well.title);
  const current = well.action ? undefined : well.items.find((item) => 'checked' in item && item.checked && 'id' in item)?.id;
  return (
    <>
      <button
        ref={menu.ref}
        type="button"
        aria-haspopup="menu"
        aria-expanded={menu.open}
        aria-label={well.label ? `${well.label}: ${well.value}` : well.value ? `${said.name}: ${well.value}` : said.name}
        onClick={menu.toggle}
        {...tip(well.title)}
        className={`flex h-[32px] min-w-0 items-center gap-[6px] rounded-[16px] px-[10px] text-[13px] text-label transition-colors hover:bg-fill-2 ${menu.open ? 'bg-fill-selected' : ''} ${wide ? 'w-full justify-between bg-fill-1' : well.label || well.action ? 'max-w-[240px] shrink-0' : 'max-w-[220px]'}`}
      >
        {well.icon ? <Icon name={well.icon} size={16} /> : null}
        {well.label ? <span className="shrink-0 text-label-2">{well.label}</span> : null}
        {well.value ? <span className={`truncate ${wide && well.label ? 'flex-1 text-left' : ''}`}>{well.value}</span> : null}
        {well.action ? null : <Icon name="chevron-up-down" size={ICON_SIZE.indicator} />}
      </button>
      <Menu open={menu.open} anchor={menu.anchor} onClose={menu.close} placement={placement} align="center" label={said.name} width={well.action ? 240 : 260} items={well.items} current={current} />
    </>
  );
}
